// app/javascript/controllers/table_selection_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupEventListeners()
    this.updateActionRowColspan()
    this.setupGlobalFunctions()
  }

  setupEventListeners() {
    // Select All checkbox
    this.element.querySelector('#selectAll')?.addEventListener('change', (e) => {
      const checkboxes = this.element.querySelectorAll('.table-custom input[type="checkbox"]')
      checkboxes.forEach(checkbox => checkbox.checked = e.target.checked)
      this.updateSelectionState()
    })

    // Individual checkboxes
    this.element.querySelectorAll('.table-custom input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updateSelectionState())
    })
  }

  updateSelectionState() {
    const checkboxes = this.element.querySelectorAll('.table-custom input[type="checkbox"]')
    const actionRow = this.element.querySelector('.action-row')
    const isAnyChecked = Array.from(checkboxes).some(cb => cb.checked)
    
    actionRow.style.display = isAnyChecked ? 'table-row' : 'none'
    this.updateSelectedCount()
  }

  updateSelectedCount() {
    const checkboxes = this.element.querySelectorAll('.table-custom .checkbox:checked')
    const selectedCount = checkboxes.length
    const selectedCountElement = this.element.querySelector('#selected-count')
    
    if (selectedCountElement && selectedCount > 0) {
      selectedCountElement.textContent = `${selectedCount} Row${selectedCount !== 1 ? 's' : ''} Selected`
    }
  }

  updateActionRowColspan() {
    const table = this.element.querySelector('.table-custom')
    const actionRowCell = this.element.querySelector('#action-row-cell')
    
    if (table && actionRowCell && table.rows.length > 0) {
      actionRowCell.colSpan = table.rows[0].cells.length
    }
  }

  // Add this new method
  setupGlobalFunctions() {
    window.getCheckedIds = () => this.getCheckedIds()
    window.closeActionRow = () => this.closeActionRow()
  }

  // Keep your existing global functions
  closeActionRow() {
    this.element.querySelectorAll('.table-custom input[type="checkbox"]').forEach(cb => cb.checked = false)
    this.element.querySelector('.action-row').style.display = 'none'
  }

  getCheckedIds() {
    return Array.from(this.element.querySelectorAll('.table-custom .checkbox:checked'))
      .map(checkbox => checkbox.closest('tr').dataset.id)
  }
}